// Non-component helpers for the read-only payment inboxes (PayPal, Mercury).
// Kept separate from payment-inbox.tsx so that file only exports components
// (keeps react-refresh happy).

export type MatchStatus = "unmatched" | "suggested" | "matched" | "rejected";
export type MatchAction = "match" | "reject" | "unmatch";

export type PendingKey = string; // `${paymentId}:${action}`

export function makePendingKey(id: string, action: MatchAction): PendingKey {
  return `${id}:${action}`;
}
